import { createRouter, createWebHistory } from 'vue-router'

function setPropsFromQueryString(route: any) {
  return { 
    client_id: route.query.client_id, response_type: route.query.response_type, redirect_uri: route.query.redirect_uri, 
    scope: route.query.scope, state: route.query.state, initiator: route.query.initiator, unauthorized: route.query.unauthorized,
    domain: route.query.domain
  }
}

const routes = [
  { name: 'Home', path: '/home', component: () => import('../views/Home.vue') },
  {
    name: 'Documentation', path: '/docs', meta: { requiresAuth: false }, props: true,
    component: () => import('../views/Documentation.vue'),
    children: [
      { name: 'Intro', path: 'intro', meta: { requiresAuth: false } , component: () => import('../components/documentation/Intro.vue')},
      { name: 'Search', path: 'search', meta: { requiresAuth: false }, component: () => import("../components/documentation/Search.vue") },
      { name: 'Usage', path: 'usage', meta: { requiresAuth: false }, component: () => import("../components/documentation/Usage.vue") },
      { name: 'Webhooks', path: 'webhooks', meta: { requiresAuth: false }, component: () => import("../components/documentation/Webhooks.vue") },
    ],
  },
  {
    name: 'Auth', path: '/auth',
    props: (route: any) => setPropsFromQueryString(route),
    component: () => import('../views/Auth.vue'),
    children: [
      { 
        name: 'Login', path: 'login', meta: { requiresAuth: false }, 
        props: (route: any) => setPropsFromQueryString(route),
        component: () => import('../components/auth/Login.vue') 
      },
      { name: 'Scopes', path: 'login/scopes', meta: { requiresAuth: false } , props: true, component: () => import('../components/auth/Scopes.vue') },
      { 
        name: 'TokenDisplay', path: 'token/display', meta: { requiresAuth: false } , 
        props: (route: any) => ({ access_token: route.query.access_token}),
        component: () => import('../components/auth/TokenDisplay.vue') 
      },
      { name: 'Unauthorized',  path : 'unauthorized', meta: { requiresAuth: false }, component: () => import('../components/auth/Unauthorized.vue') },
      { 
        name: 'OktaLogin',
        path: 'login/okta/response', 
        props: (route: any) => ({ access_token: route.hash.split("&")[0].replace("#access_token=","") }),
        component: () => import('../components/auth/OktaLogin.vue') 
      },
    ],
  },
  {
    name: 'Dashboard', path: '/dashboard', props: true, meta: { requiresAuth: false },
    component: () => import('../views/Dashboard.vue'),
    children: [
      { 
        name: 'IntegrationTests',  path: 'admin/integrationtests', meta: { requiresAuth: true }, props: true,
        component: () => import('../components/dashboard/admin/IntegrationTests.vue') 
      },
      {
        name: 'TokenManagement',  path: 'tokens', meta: { requiresAuth: false }, props: true,
        component: () => import('../components/dashboard/tokens/TokenManagement.vue') 
      },
      {
        name: 'Admin',  path: 'admin', meta: { requiresAuth: true }, props: true,
        component: () => import('../components/dashboard/admin/Admin.vue') 
      },
      {
        name: 'Processes',  path: 'admin/processes', meta: { requiresAuth: true }, props: true,
        component: () => import('../components/dashboard/admin/Processes.vue') 
      },
    ]

  },
]

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
})

import store from '@/store'
import SecureLS from 'secure-ls'
import { Config } from "../models/Config";
const config : Config = require("../../config.json");
const secret : string = config.secret;
var ls = new SecureLS({ encodingType: 'aes', encryptionSecret: secret, isCompression: true });

router.beforeEach(async (to, from, next) => {
  if (to.matched.length === 0) {
    next({ path: '/docs/intro'}); 
    return; 
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    const adminCookie : string = ls.get('vuex') !== "" ? JSON.parse(ls.get('vuex'))?.userstate?.AdminCookie : null;
    if (adminCookie == null) {
      next({ path: '/docs/intro'}); 
      return;
    }
    await store.state.axiosService.VerifyAdmin()
    .then((response : any) => {
      if (response == null || !response.isValid) {
        next({ path: '/auth/unauthorized'}); 
        return;
      }
    })
    .catch(() => {
      next({ path: '/docs/intro'}); 
      return;
    })

  }
  if (document.getElementsByClassName('content').length > 0) {//set the scroll to the top component of the new component
    document.getElementsByClassName('content')[0].scrollTop = 0;//reset screen scroll when navigating to new routes.
  }
  next();
});

export default router
